import { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { getVibeBulks } from "../api/vibe/index";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../components/pages/CustomPageHeader";

const VibesBulks = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("0.00");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getVibeBulks();
        setAmount(res?.data?.amount || "0.00");
        setHistory(res?.data?.data?.data || []);
      } catch (err) {
        setAmount("0.00");
        setHistory([]);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <>
      <CustomPageHeader
        pageContainerClass=""
        title={t("vibe_bucks", "Vibelinks")}
        // hideBack={true}
        // showPageHeader={false}
      >
        <div className="min-h-screen flex flex-col items-center pt-8 pb-20">
          <div className="w-full max-w-xl">
            <div className="flex flex-col items-center mb-8">
              <span className="text-5xl font-extrabold text-gray-900 dark:text-white">
                ${parseFloat(amount).toFixed(2)}
              </span>
            </div>
            <div className="mb-4">
              <span className="text-2xl font-bold text-gray-700 dark:text-white">
                {t("history")}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              {loading ? (
                <div className="text-gray-400 text-lg font-semibold">
                  {t("loading", "Loading...")}
                </div>
              ) : history.length === 0 ? (
                <div className="text-gray-400 text-lg font-semibold">
                  {t("no_history_found", "No history found.")}
                </div>
              ) : (
                history.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-center bg-white dark:bg-[#252739] rounded-xl shadow px-4 py-3"
                  >
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 flex items-center justify-center mr-3">
                      {item.member?.image ? (
                        <img
                          src={item.member.image}
                          alt={item.member.full_name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <FaUser className="text-gray-400 dark:text-gray-300 text-2xl" />
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 dark:text-white text-base">
                        {item.member?.full_name ||
                          t("deleted_user", "Deleted user")}
                      </div>
                    </div>
                    <div className="text-gray-400 dark:text-gray-300 text-sm">
                      {formatDate(item.created_at)}
                    </div>
                    <div className="font-bold text-lg text-gray-800 dark:text-white ml-4">
                      +{parseFloat(item.amount).toFixed(2)}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </CustomPageHeader>
    </>
  );
};

export default VibesBulks;
